var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutgoingTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FFF6E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8054 10.6667H8.10383C7.9439 10.6667 7.81824 10.4804 7.81824 10.2434V8.42328C7.81824 8.18624 7.9439 8 8.10383 8H24.8054C24.9653 8 25.091 8.18624 25.091 8.42328V10.2434C25.091 10.4804 24.9653 10.6667 24.8054 10.6667Z",
    fill: "#EEBC6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9009 8.53516C10.7157 8.53516 10.6099 8.72451 10.7289 8.85299C11.2911 9.46838 12.2898 10.9629 11.6086 13.323C10.6959 16.4608 8.18265 18.5436 9.2673 23.8386C9.28714 23.9333 9.37974 24.0009 9.48556 24.0009H18.9565C19.1284 24.0009 19.2342 23.8319 19.1416 23.7034C18.8374 23.2503 18.4406 22.2697 18.9763 20.5656C19.4525 19.0508 23.2752 12.8631 20.4644 8.62983C20.4247 8.56897 20.352 8.53516 20.2726 8.53516H10.9009Z",
    fill: "#EEBC6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2461 13.248V13.9446",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2461 18.5898V19.2864",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.246 16.2638C14.5251 16.2638 13.9431 15.7431 13.9431 15.1006C13.9431 14.4582 14.5251 13.9375 15.246 13.9375C15.9669 13.9375 16.5489 14.4582 16.5489 15.1006",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.246 16.2637C15.9669 16.2637 16.5489 16.7844 16.5489 17.4268C16.5489 18.0692 15.9669 18.59 15.246 18.59C14.5251 18.59 13.9431 18.0692 13.9431 17.4268",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingTransfer);
export default __webpack_public_path__ + "static/media/outgoing-transfer.b443938a.svg";
export { ForwardRef as ReactComponent };